export const getStyleWithImportant = (style) => `${style} !important`;
